import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
// Copy options for the headline — swap the active one inside the JSX below.
// 1. 'Integra Aisac e scopri i vantaggi che puoi ottenere da subito.'
// 2. 'Connetti Aisac. Vedi i risultati sui tuoi numeri reali.'
// 3. 'In 15 minuti, Aisac è già al lavoro sui tuoi ordini.'
// 4. 'Il prossimo ordine può costare meno. Iniziamo da oggi.'
type Benefit = {
  label: string;
  caption: string;
};
const benefits: Benefit[] = [{
  label: 'Insight in 24 ore',
  caption: 'Audit gratuito sui tuoi ultimi 30 giorni di spedizioni.'
}, {
  label: 'Zero integrazione manuale',
  caption: 'Connessione nativa a Shopify, WooCommerce e i principali corrieri.'
}, {
  label: 'Nessun lock-in',
  caption: 'Paghi solo per quello che usi, disattivi quando vuoi.'
}, {
  label: 'Risultati misurabili',
  caption: '−18% sui costi di delivery medi post-integrazione.'
}];
export function FinalCTA() {
  return <section className="section-pad border-t border-default relative overflow-hidden" id="cta" data-id="element-77">
      {/* Radial accent — anchored behind the left column */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/3 w-[720px] h-[720px] bg-[radial-gradient(circle,var(--accent-100),transparent_65%)] pointer-events-none opacity-60 hidden md:block" data-id="element-78"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[480px] h-[480px] bg-[radial-gradient(circle,var(--accent-100),transparent_70%)] pointer-events-none opacity-40 md:hidden" data-id="element-79"></div>

      <div className="wrap relative z-10" data-id="element-80">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-[var(--s-12)] items-start" data-id="element-81">
          {/* LEFT — Editorial statement */}
          <AnimatedSection delay={0} data-id="element-82">
            <div className="lg:sticky lg:top-[120px]" data-id="element-83">
              <div className="section-tag section-tag--accent mb-6" data-id="element-84">
                INIZIA ORA
              </div>

              <h2 className="text-display-section mb-6" data-id="element-85">
                Connetti Aisac e{' '}
                <strong className="color-accent font-medium" data-id="element-86">
                  riduci i costi
                </strong>{' '}
                delle tue spedizioni. Già dal primo mese.
              </h2>

              <p className="text-body-lg color-ink-secondary mb-10 max-w-[52ch]" data-id="element-87">
                Ti mostriamo i tuoi dati, non i nostri. Demo gratuita, zero
                impegno, primi insight in 24 ore.
              </p>

              {/* Benefits list */}
              <ul className="flex flex-col gap-5 mb-10" data-id="element-88">
                {benefits.map((b, i) => <AnimatedSection key={b.label} delay={0.05 + i * 0.05} data-id="element-89">
                    <li className="flex items-start gap-4" data-id="element-90">
                      <span className="shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full border border-[var(--accent-500)] bg-[var(--accent-100)]/20" aria-hidden="true" data-id="element-91">
                        <Check className="w-3.5 h-3.5 color-accent" strokeWidth={2.5} data-id="element-92" />
                      </span>
                      <div className="flex-1" data-id="element-93">
                        <div className="text-body-base color-ink-primary font-medium mb-1" data-id="element-94">
                          {b.label}
                        </div>
                        <div className="text-body-sm color-ink-tertiary leading-relaxed" data-id="element-95">
                          {b.caption}
                        </div>
                      </div>
                    </li>
                  </AnimatedSection>)}
              </ul>

              {/* Social proof */}
              <div className="pt-6 border-t border-default" data-id="element-96">
                <p className="text-body-sm color-ink-tertiary" data-id="element-97">
                  <span className="color-ink-secondary" data-id="element-98">
                    Già scelto da merchant con
                  </span>{' '}
                  <strong className="color-ink-primary font-medium" data-id="element-99">
                    300K+ ordini processati
                  </strong>{' '}
                  sulla piattaforma.
                </p>
              </div>
            </div>
          </AnimatedSection>

          {/* RIGHT — Demo form */}
          <AnimatedSection delay={0.1} data-id="element-100">
            <form className="bg-elev2 border border-default rounded-[var(--r-xl)] p-6 md:p-8 flex flex-col gap-5 shadow-[var(--shadow-lg)]" data-id="element-101">
              <div className="mb-1" data-id="element-102">
                <div className="text-mono-tiny tracking-wider color-ink-tertiary uppercase mb-2" data-id="element-103">
                  Demo gratuita
                </div>
                <div className="color-ink-primary" style={{
                fontFamily: 'var(--font-display)',
                fontSize: '22px',
                fontWeight: 500,
                letterSpacing: '-0.02em',
                lineHeight: 1.2
              }} data-id="element-104">
                  Richiedi una demo
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-105">
                <div className="flex flex-col gap-2" data-id="element-106">
                  <label htmlFor="nome" className="text-mono-tiny color-ink-secondary" data-id="element-107">
                    Nome e Cognome
                  </label>
                  <input type="text" id="nome" className="bg-elev1 border border-default rounded-[var(--r-md)] px-4 py-3 text-body-base color-ink-primary focus:outline-none focus:border-[var(--accent-500)] transition-colors" placeholder="Mario Rossi" data-id="element-108" />
                </div>
                <div className="flex flex-col gap-2" data-id="element-109">
                  <label htmlFor="azienda" className="text-mono-tiny color-ink-secondary" data-id="element-110">
                    Azienda
                  </label>
                  <input type="text" id="azienda" className="bg-elev1 border border-default rounded-[var(--r-md)] px-4 py-3 text-body-base color-ink-primary focus:outline-none focus:border-[var(--accent-500)] transition-colors" placeholder="Nome azienda" data-id="element-111" />
                </div>
              </div>

              <div className="flex flex-col gap-2" data-id="element-112">
                <label htmlFor="email" className="text-mono-tiny color-ink-secondary" data-id="element-113">
                  Email aziendale
                </label>
                <input type="email" id="email" className="bg-elev1 border border-default rounded-[var(--r-md)] px-4 py-3 text-body-base color-ink-primary focus:outline-none focus:border-[var(--accent-500)] transition-colors" placeholder="mario@azienda.it" data-id="element-114" />
              </div>

              <div className="flex flex-col gap-2" data-id="element-115">
                <label htmlFor="volume" className="text-mono-tiny color-ink-secondary" data-id="element-116">
                  Volume mensile spedizioni
                </label>
                <select id="volume" className="bg-elev1 border border-default rounded-[var(--r-md)] px-4 py-3 text-body-base color-ink-primary focus:outline-none focus:border-[var(--accent-500)] transition-colors appearance-none" defaultValue="" data-id="element-117">
                  <option value="" disabled data-id="element-118">
                    Seleziona un volume
                  </option>
                  <option value="<1k" data-id="element-119">Meno di 1.000</option>
                  <option value="1k-10k" data-id="element-120">1.000 - 10.000</option>
                  <option value="10k-100k" data-id="element-121">10.000 - 100.000</option>
                  <option value=">100k" data-id="element-122">Oltre 100.000</option>
                </select>
              </div>

              <div className="flex flex-col gap-2" data-id="element-123">
                <label htmlFor="messaggio" className="text-mono-tiny color-ink-secondary" data-id="element-124">
                  Messaggio (opzionale)
                </label>
                <textarea id="messaggio" rows={3} className="bg-elev1 border border-default rounded-[var(--r-md)] px-4 py-3 text-body-base color-ink-primary focus:outline-none focus:border-[var(--accent-500)] transition-colors resize-none" placeholder="Raccontaci la tua esigenza..." data-id="element-125"></textarea>
              </div>

              <button type="button" className="btn-primary w-full justify-center mt-2" data-id="element-126">
                Richiedi demo
                <ArrowRight className="w-5 h-5" data-id="element-127" />
              </button>

              <p className="text-body-sm color-ink-tertiary text-center mt-1" data-id="element-128">
                Ti rispondiamo entro 1 giorno lavorativo.
              </p>
            </form>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}